import * as styles from "./styles.css";
import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
export const ProgressBar = ({ className, durationM, viewingHistoryM, }) => {
    const duration = M.fromMaybe(durationM, 0);
    const viewingHistory = M.map((viewingHistory) => {
        const position = M.fromMaybe(viewingHistory.position, 0);
        const progress = duration === 0 ? 0 : (position / duration) * 100;
        const width = `${progress}%`;
        return progress > 0 ? (React.createElement("div", { className: cn(styles.progressBar, className), id: "progressBar" },
            React.createElement("div", { className: styles.progress, style: { width: width } }))) : (React.createElement(React.Fragment, null));
    }, viewingHistoryM);
    return React.createElement(RenderMaybe, null, viewingHistory);
};

